import React from "react";
import { useNavigate } from "react-router-dom";

const ValidateUserPlan = () => {
  const navigate = useNavigate();

  const handleRenewClick = () => {
    window.open("https://www.nssofttech.com/login/");
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center px-4">
      <h2 className="fw-bold mb-3" style={{ fontSize: "2.5rem", color: "black" }}>
        Your plan has expired.
      </h2>
      <p className="mb-4" style={{ fontSize: "1.25rem", color: "black" }}>
        To continue using the application, please renew your subscription.
      </p>
      <button
        onClick={handleRenewClick}
        style={{ fontSize: "1.2rem" }}
        className="btn btn-primary"
      >
        Renew Plan
      </button>
    </div>
  );
};

export default ValidateUserPlan;
